import axios from 'axios'
import moment from 'moment'
import {
  GET_REFERRALS_COUNT,
  GET_REFERRALS_LIST,
  GET_REFERRAL,
  CREATE_NEW_REFERRAL,
  ADD_REFERRAL,
  UPDATE_REFERRAL_SAVE,
  UPDATE_REFERRAL_SAVE_AND_CLOSE,
  TRANSFER_REFERRAL
} from './action-constants'

const TABLENAME = 'referrals'
const TABLENAME_BY_LOGIN_ID =
  'referrals/bylogin' /*** ROUTE UPDATED TO ADD SECURITY MEASURES */
const TABLENAME_REFERRAL_TRANSFER = 'referrals/transfer'
const TABLENAME_REFERRAL_COUNT = 'referrals/count'

export function getReferralsCount (loginID) {
  const JSONURL = process.env.REACT_APP_DATABASE_URL + '/' + TABLENAME_REFERRAL_COUNT + '/' + loginID
  return {
    type: GET_REFERRALS_COUNT,
    payload: new Promise((resolve, reject) => {
      axios
        .get(
          JSONURL
        )
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  }
}

export function getReferralsList (loginID) {
  const JSONURL = process.env.REACT_APP_DATABASE_URL + '/' + TABLENAME_BY_LOGIN_ID + '/' + loginID
  return {
    type: GET_REFERRALS_LIST,
    payload: new Promise((resolve, reject) => {
      axios
        .get(
          JSONURL
        )
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  }
}

export function getReferral (id) {
  const JSONURL = process.env.REACT_APP_DATABASE_URL + '/' + TABLENAME + '/' + id
  return {
    type: GET_REFERRAL,
    payload: new Promise((resolve, reject) => {
      axios
        .get(
          JSONURL
        )
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  }
}

export function createNewReferral () {
  const max = 100000
  const rand = Math.floor(Math.random() * max)
  var yrsAgo18 = new Date()
  yrsAgo18.setFullYear(yrsAgo18.getFullYear() - 18)
  const initialDate_DOB = moment(yrsAgo18).format('YYYY-MM-DD')
  const initialDate_referralreceiveddate = moment(new Date()).format('YYYY-MM-DD')
  const initialDate_referralrequestedadmissiondate = moment(new Date()).format('YYYY-MM-DD')
  return {
    type: CREATE_NEW_REFERRAL,
    payload: {
      id: 0,

      /*** tab-name */
      regid: rand,
      fname: '',
      mname: '',
      lname: '',
      dob: initialDate_DOB,
      age: '',
      gender: '1',
      ethnicity: '1',

      /*** tab-dates */
      referralreceiveddate: initialDate_referralreceiveddate,
      referralrequestedadmissiondate: initialDate_referralrequestedadmissiondate,
      referralapproveddate: null,
      referralapprovedadmissiondate: null,
      referralprojectedreleasedate: null,

      /*** tab-programs */
      program: '0',
      clinicalprovidersnone: '1',
      
      /*** tab-programs - BOP RRC - Officer */
      bopsupervisingofficercomments: '',

      /*** tab-programs - BOP RRC - Program Requirements */
      bopalchoholaftercareprogram: 0,
      bopdrugaftercareprogram: 0,
      bopfinancialresponsibilityprogram: 0,
      bopmentalhealthaftercareprogram: 0,
      boppsf: 0,

      /*** tab-programs - BOP RRC - BOP Institution */
      boplevelofsecurity: 0,
      bopinstitution: 0,
      bopinstitutioncomments: '',

      /*** tab-programs - BOP RRC - Gang Affiliation */
      bopgangaffiliation: 1,
      bopgangaffiliationcomments: '',

      /*** tab-programs - OPC US PTS-Psy - Officer */
      opcusptspsyofficercomments: '',

      /*** tab-client-details */
      /*** tab-client-details - tab-conditions */
      referralhomelesshistory: 0,
      referralhomelesscurrent: 0,
      referralhomelessna: 0,
      referralmentalhealthissueshistory: 0,
      referralmentalhealthissuescurrent: 0,
      referralmentalhealthissuesna: 0,
      referralsubstanceusedisorderissueshistory: 0,
      referralsubstanceusedisorderissuescurrent: 0,
      referralsubstanceusedisorderissuesna: 0,
      referralcooccurringhistory: 0,
      referralcooccurringcurrent: 0,
      referralcooccurringna: 0,
      referralemployedduringpasthistory: 0,
      referralemployedduringpastcurrent: 0,
      referralemployedduringpastna: 0,

      referralriskasperpetrator: 0,
      referralriskofvictimization: 0,

      /*** tab-client-details - tab-referral */
      referralsource: 1,
      priorcriminalbackground: 0,
      currentinstantoffense: 1,

      /*** tab-outcome */
      referraloutcome: '2',
      referraloutcomecomments: '',
      referralcreatedbyloginid: 0,
      referrallasttouchedbyloginid: 0
    }
  }
}

export function addReferral (params) {
  const JSONURL = process.env.REACT_APP_DATABASE_URL + '/' + TABLENAME + '/'
  return {
    type: ADD_REFERRAL,
    payload: new Promise((resolve, reject) => {
      axios
        .post(
          JSONURL,
          params
        )
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  }
}

export function updateReferralSave (id, params) {
  const JSONURL = process.env.REACT_APP_DATABASE_URL + '/' + TABLENAME + '/' + id
  return {
    type: UPDATE_REFERRAL_SAVE,
    payload: new Promise((resolve, reject) => {
      axios
        .put(
          JSONURL,
          params
        )
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  }
}

export function updateReferralSaveAndClose (id, params) {
  const JSONURL = process.env.REACT_APP_DATABASE_URL + '/' + TABLENAME + '/' + id
  return {
    type: UPDATE_REFERRAL_SAVE_AND_CLOSE,
    payload: new Promise((resolve, reject) => {
      axios
        .put(
          JSONURL,
          params
        )
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  }
}

export function transferReferral (id, params) {
  const JSONURL = process.env.REACT_APP_DATABASE_URL + '/' + TABLENAME_REFERRAL_TRANSFER + '/' + id
  return {
    type: TRANSFER_REFERRAL,
    payload: new Promise((resolve, reject) => {
      axios
        .post(
          JSONURL,
          params
        )
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  }
}
